const UNKNOWN_VALUES = new Set([
  "",
  "blank",
  "n/a",
  "na",
  "none",
  "null",
  "undefined",
  "unknown",
  "unknown_city",
  "unknown_region",
  "unknown_state",
]);

const SOURCE_RANKS = {
  unknown: 0,
  ip: 10,
  browser: 20,
  stored: 40,
  route: 70,
  member_city_seo: 80,
  manual: 90,
};

const normalizeToken = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");

export const isMeaningfulLocationValue = (value) => {
  const normalized = normalizeToken(value);
  if (UNKNOWN_VALUES.has(normalized)) return false;
  if (normalized.startsWith("unknown_")) return false;
  return Boolean(normalized);
};

export const normalizeLocationSource = (location = {}, fallback = "unknown") => {
  const explicit = normalizeToken(location?.locationSource || location?.source || "");

  if (explicit === "member_city_seo" || explicit === "member_seo") {
    return "member_city_seo";
  }
  if (explicit.includes("member_city_seo") || explicit.includes("member_seo")) {
    return "member_city_seo";
  }
  if (explicit.includes("manual") || explicit.includes("google")) return "manual";
  if (explicit.includes("route")) return "route";
  if (explicit.includes("stored")) return "stored";
  if (explicit.includes("browser")) return "browser";
  if (explicit.includes("ip")) return "ip";

  if (location?.formattedAddress || location?.placeId || location?.line1) {
    return "manual";
  }
  if (location?.routePath || location?.placeGeoId) return "member_city_seo";
  if (location?.ip) return "ip";

  return normalizeToken(fallback) || "unknown";
};

export const getLocationSourceRank = (locationOrSource = {}) => {
  const source =
    typeof locationOrSource === "string"
      ? normalizeLocationSource({ locationSource: locationOrSource })
      : normalizeLocationSource(locationOrSource);
  return SOURCE_RANKS[source] ?? SOURCE_RANKS.unknown;
};

export const hasDisplayableLocation = (location = {}) =>
  [
    location?.city,
    location?.locality,
    location?.state,
    location?.region,
    location?.stateCode,
    location?.state_code,
    location?.region_code,
    location?.postal,
    location?.zipCode,
  ].some(isMeaningfulLocationValue);

export const hasExplicitLocation = (location = {}) =>
  hasDisplayableLocation(location) &&
  getLocationSourceRank(location) >= SOURCE_RANKS.route;

export const hasUserSelectedLocation = (location = {}) =>
  hasDisplayableLocation(location) &&
  getLocationSourceRank(location) >= SOURCE_RANKS.manual;

export const _private = {
  SOURCE_RANKS,
  normalizeToken,
};
